import { graphql, HttpResponse } from 'msw'
import {
  MaritalStatus,
  type EnrollmentJointAccountTypeData,
  type EnrollmentJointAccountTypeSubmitOutput,
} from '../../../../models'

export const getEnrollmentJointAccountTypeDataMock: EnrollmentJointAccountTypeData = {
  activePerson: {
    path: '/enrollment/joint/account-selection',
    progress: 10,
    maritalStatus: MaritalStatus.MARRIED,
    addressRegionCode: 'NY',
    name: {
      firstName: 'John',
      lastName: 'Doe',
    },
  },
  eligibleAccountTypes: [
    'JOINT_TENANTS_WITH_RIGHT_OF_SURVIVORSHIP',
    'TENANTS_IN_COMMON',
    'JOINT_COMMUNITY_PROPERTY',
    'JOINT_TENANTS_BY_THE_ENTIRETY',
  ],
  accountType: 'JOINT_TENANTS_WITH_RIGHT_OF_SURVIVORSHIP',
  errors: [],
  isError: false,
}

export const submitEnrollmentJointAccountTypeDataMock: EnrollmentJointAccountTypeSubmitOutput = {
  errors: [],
  isError: false,
  activePerson: {
    path: '/enrollment/joint/contact-info',
  },
}

export const mockGetEnrollmentJointAccountTypeData = graphql.mutation('getEnrollmentJointAccountTypeData', () => {
  return HttpResponse.json({ data: { submitJointEnrollment: getEnrollmentJointAccountTypeDataMock } })
})

export const mockSubmitEnrollmentJointAccountTypeData = graphql.mutation(
  'submitJointEnrollmentJointAccountTypeData',
  () => {
    return HttpResponse.json({ data: { submitJointEnrollment: submitEnrollmentJointAccountTypeDataMock } })
  },
)

export const mockEnrollmentJointAccountType = [
  mockGetEnrollmentJointAccountTypeData,
  mockSubmitEnrollmentJointAccountTypeData,
]
